import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET } from '../SQL'
import { TratamientoDeParametroParaURI } from '../Varios';

export const function_CONT_Reportes_ReporteIVAComprasVsIVAVentas = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CONT_Reportes_ReporteIVAComprasVsIVAVentas"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ReporteIVAComprasVsIVAVentas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ReportePedidosVsVentas = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CONT_Reportes_ReportePedidosVsVentas"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ReportePedidosVsVentas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ProveedorConSaldo = async (IdProveedor) => {
    const NombreFuncion = "function_CONT_Reportes_ProveedorConSaldo"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ProveedorConSaldo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdProveedor);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ProveedorConDeuda = async () => {
    const NombreFuncion = "function_CONT_Reportes_ProveedorConDeuda"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ProveedorConDeuda/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ProveedorConDeudaFechaCorte = async (FechaCorte) => {
    const NombreFuncion = "function_CONT_Reportes_ProveedorConDeudaFechaCorte"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ProveedorConDeudaFechaCorte/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaCorte);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ClientesConSaldo = async (IdCliente) => {
    const NombreFuncion = "function_CONT_Reportes_ClientesConSaldo"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ClientesConSaldo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ClientesConDeuda = async () => {
    const NombreFuncion = "function_CONT_Reportes_ClientesConDeuda"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ClientesConDeuda/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_ClientesConDeudaFechaCorte = async (FechaCorte) => {
    const NombreFuncion = "function_CONT_Reportes_ClientesConDeudaFechaCorte"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/ClientesConDeudaFechaCorte/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaCorte);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_Articulo = async (FechaDesde, FechaHasta, CodigoArticulo) => {
    const NombreFuncion = "function_CONT_Reportes_Articulo"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/Articulo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_CentroCosto = async (FechaDesde, FechaHasta, CodigoCC, CodigoSubCC) => {
    const NombreFuncion = "function_CONT_Reportes_CentroCosto"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/CentroCosto/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(CodigoCC) + "/" +
            await TratamientoDeParametroParaURI(CodigoSubCC));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_GeneralProductivo = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CONT_Reportes_GeneralProductivo"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/GeneralProductivo/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_CuentaFinanciera = async (FechaDesde, FechaHasta, CodigoCuentaFinanciera) => {
    const NombreFuncion = "function_CONT_Reportes_CuentaFinanciera"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/CuentaFinanciera/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            await TratamientoDeParametroParaURI(CodigoCuentaFinanciera));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_CuentaFinanciera_Balance = async (FechaCorte) => {
    const NombreFuncion = "function_CONT_Reportes_CuentaFinanciera_Balance"
    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/CuentaFinanciera_Balance/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaCorte);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_IVAVentas = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CONT_Reportes_IVAVentas"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/IVAVentas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CONT_Reportes_IVACompras = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CONT_Reportes_IVACompras"

    try {
        const resulData = await llamadaAPI_GET("CONT_Reportes/IVACompras/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};